import { useState, useMemo, useEffect } from "react"
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Input,
  Select,
  Switch,
  useDisclosure,
  useToast,
  FormControl,
  FormLabel,
  NumberInput,
  NumberInputField,
  Textarea,
  VStack,
  HStack,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Badge,
  Flex,
  IconButton,
  Container,
  InputGroup,
  InputLeftElement,
  TableContainer,
  Checkbox,
} from "@chakra-ui/react"
import { AddIcon, ViewIcon, EditIcon, DeleteIcon, SearchIcon } from "@chakra-ui/icons"
import { useDispatch, useSelector } from "react-redux"
import {
  fetchSubscriptionasync,
  selectSubscription,
  addSubscriptionasync,
  updateSubscriptionasync,
  deleteSubscriptionasync,
} from "../../Subscriptions/SubscriptionDetails/SubscriptionSlice"

const initialPlanState = {
  type: "",
  is_default: false,
  title: "",
  description: "",
  subscription_type: "",
  mrp_amount: "",
  amount: "",
  sort_order: "",
  subscription_feature: [],
  validity: "",
  validity_type: "day",
  status: "active",
  profile_creation: false,
  no_of_job_apply: 0,
  resume_builder: false,
  notification_via_email_sms_whatsapp: false,
  no_of_job_post: 0,
  no_of_urgent_hiring_tag: 0,
  no_of_candidate_unlock: 0,
  no_of_job_published: 0,
  job_boosts: false,
  smart_boost_via_email_sms_whatsapp: false,
  dedicated_relationship_manager: false,
  campion_via_email_sms_whatsapp: false,
  multiple_user_login: false,
  reports: false,
  company_branding: false,
}

const CreatePlan = () => {
  const dispatch = useDispatch()
  const subscriptions = useSelector(selectSubscription)
  const [currentPlan, setCurrentPlan] = useState(initialPlanState)
  const [selectedPlans, setSelectedPlans] = useState([])
  const [searchTerm, setSearchTerm] = useState("")
  const [userTypeFilter, setUserTypeFilter] = useState("all")
  const [subscriptionTypeFilter, setSubscriptionTypeFilter] = useState("all")

  const { isOpen: isAddOpen, onOpen: onAddOpen, onClose: onAddClose } = useDisclosure()
  const { isOpen: isEditOpen, onOpen: onEditOpen, onClose: onEditClose } = useDisclosure()
  const { isOpen: isDeleteOpen, onOpen: onDeleteOpen, onClose: onDeleteClose } = useDisclosure()
  const { isOpen: isViewOpen, onOpen: onViewOpen, onClose: onViewClose } = useDisclosure()

  const toast = useToast()

  useEffect(() => {
    dispatch(fetchSubscriptionasync())
  }, [dispatch])

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setCurrentPlan({ ...currentPlan, [name]: value })
  }

  const handleSwitchChange = (name) => {
    setCurrentPlan({ ...currentPlan, [name]: !currentPlan[name] })
  }

  const handleNumberInputChange = (name, value) => {
    setCurrentPlan({ ...currentPlan, [name]: value })
  }

  const handleFeatureChange = (index, field, value) => {
    const updatedFeatures = [...currentPlan.subscription_feature]
    updatedFeatures[index] = { ...updatedFeatures[index], [field]: value }
    setCurrentPlan({ ...currentPlan, subscription_feature: updatedFeatures })
  }

  const addFeature = () => {
    setCurrentPlan({
      ...currentPlan,
      subscription_feature: [...currentPlan.subscription_feature, { feature: "", sort_order: "" }],
    })
  }

  const removeFeature = (index) => {
    const updatedFeatures = currentPlan.subscription_feature.filter((_, i) => i !== index)
    setCurrentPlan({ ...currentPlan, subscription_feature: updatedFeatures })
  }

  const handleAddPlan = async () => {
    try {
      const newPlan = {
        ...currentPlan,
        mrp_amount: Number.parseFloat(currentPlan.mrp_amount),
        amount: Number.parseFloat(currentPlan.amount),
        sort_order: Number.parseInt(currentPlan.sort_order),
        validity: Number.parseInt(currentPlan.validity),
        no_of_job_apply: Number.parseInt(currentPlan.no_of_job_apply),
        no_of_job_post: Number.parseInt(currentPlan.no_of_job_post),
        no_of_urgent_hiring_tag: Number.parseInt(currentPlan.no_of_urgent_hiring_tag),
        no_of_candidate_unlock: Number.parseInt(currentPlan.no_of_candidate_unlock),
        no_of_job_published: Number.parseInt(currentPlan.no_of_job_published),
      }
      await dispatch(addSubscriptionasync(newPlan)).unwrap()
      toast({
        title: "Plan added successfully.",
        status: "success",
        duration: 2000,
        isClosable: true,
      })
      setCurrentPlan(initialPlanState)
      onAddClose()
      dispatch(fetchSubscriptionasync())
    } catch (error) {
      toast({
        title: "Failed to add plan.",
        description: error.toString(),
        status: "error",
        duration: 2000,
        isClosable: true,
      })
    }
  }

  const handleUpdatePlan = async () => {
    try {
      const updatedPlan = {
        ...currentPlan,
        mrp_amount: Number.parseFloat(currentPlan.mrp_amount),
        amount: Number.parseFloat(currentPlan.amount),
        sort_order: Number.parseInt(currentPlan.sort_order),
        validity: Number.parseInt(currentPlan.validity),
        no_of_job_apply: Number.parseInt(currentPlan.no_of_job_apply),
        no_of_job_post: Number.parseInt(currentPlan.no_of_job_post),
        no_of_urgent_hiring_tag: Number.parseInt(currentPlan.no_of_urgent_hiring_tag),
        no_of_candidate_unlock: Number.parseInt(currentPlan.no_of_candidate_unlock),
        no_of_job_published: Number.parseInt(currentPlan.no_of_job_published),
      }
      await dispatch(updateSubscriptionasync({ id: currentPlan.uuid, updateSubscriptiondata: updatedPlan })).unwrap()
      toast({
        title: "Plan updated successfully.",
        status: "success",
        duration: 2000,
        isClosable: true,
      })
      setCurrentPlan(initialPlanState)
      onEditClose()
      dispatch(fetchSubscriptionasync())
    } catch (error) {
      toast({
        title: "Failed to update plan.",
        description: error.toString(),
        status: "error",
        duration: 2000,
        isClosable: true,
      })
    }
  }

  const handleDeletePlan = async () => {
    try {
      await dispatch(deleteSubscriptionasync(currentPlan.uuid)).unwrap()
      toast({
        title: "Plan deleted successfully.",
        status: "success",
        duration: 2000,
        isClosable: true,
      })
      setCurrentPlan(initialPlanState)
      onDeleteClose()
      dispatch(fetchSubscriptionasync())
    } catch (error) {
      toast({
        title: "Failed to delete plan.",
        description: error.toString(),
        status: "error",
        duration: 2000,
        isClosable: true,
      })
    }
  }

  const handleEditPlan = (plan) => {
    setCurrentPlan(plan)
    onEditOpen()
  }

  const handleDeleteConfirmation = (planId) => {
    const planToDelete = subscriptions.find((plan) => plan.uuid === planId)
    if (planToDelete) {
      setCurrentPlan(planToDelete)
      onDeleteOpen()
    }
  }

  const handleViewPlan = (plan) => {
    setCurrentPlan(plan)
    onViewOpen()
  }

  const toggleSelectAll = () => {
    if (selectedPlans.length === filteredPlans.length) {
      setSelectedPlans([])
    } else {
      setSelectedPlans(filteredPlans.map((plan) => plan.uuid))
    }
  }

  const togglePlanSelection = (planId) => {
    if (selectedPlans.includes(planId)) {
      setSelectedPlans(selectedPlans.filter((id) => id !== planId))
    } else {
      setSelectedPlans([...selectedPlans, planId])
    }
  }

  const filteredPlans = useMemo(() => {
    if (!Array.isArray(subscriptions)) return []

    return subscriptions.filter((plan) => {
      if (!plan) return false

      const nameMatch =
        plan.title && typeof plan.title === "string"
          ? plan.title.toLowerCase().includes((searchTerm || "").toLowerCase())
          : false

      const userTypeMatch = userTypeFilter === "all" || plan.type === userTypeFilter
      const subscriptionTypeMatch =
        subscriptionTypeFilter === "all" || plan.subscription_type === subscriptionTypeFilter

      return nameMatch && userTypeMatch && subscriptionTypeMatch
    })
  }, [subscriptions, searchTerm, userTypeFilter, subscriptionTypeFilter])

  const renderPlanForm = () => (
    <VStack spacing={4}>
      <FormControl>
        <FormLabel>Type</FormLabel>
        <Select name="type" value={currentPlan.type || "employer"} onChange={handleInputChange}>
          <option value="employer">Employer</option>
          <option value="candidate">Candidate</option>
        </Select>
      </FormControl>

      <FormControl>
        <FormLabel>Is Default</FormLabel>
        <Switch isChecked={currentPlan.is_default} onChange={() => handleSwitchChange("is_default")} />
      </FormControl>

      <FormControl>
        <FormLabel>Title</FormLabel>
        <Input name="title" value={currentPlan.title} onChange={handleInputChange} />
      </FormControl>

      <FormControl>
        <FormLabel>Description</FormLabel>
        <Textarea name="description" value={currentPlan.description} onChange={handleInputChange} />
      </FormControl>

      <FormControl>
        <FormLabel>Subscription Type</FormLabel>
        <Select name="subscription_type" value={currentPlan.subscription_type} onChange={handleInputChange}>
          <option value="Premium">Premium</option>
          <option value="Basic">Basic</option>
          <option value="Standard">Standard</option>
          <option value="Custom">Custom</option>
        </Select>
      </FormControl>

      <HStack width="100%">
        <FormControl>
          <FormLabel>MRP Amount</FormLabel>
          <NumberInput min={0}>
            <NumberInputField
              name="mrp_amount"
              value={currentPlan.mrp_amount}
              onChange={(e) => handleNumberInputChange("mrp_amount", e.target.value)}
            />
          </NumberInput>
        </FormControl>

        <FormControl>
          <FormLabel>Amount</FormLabel>
          <NumberInput min={0}>
            <NumberInputField
              name="amount"
              value={currentPlan.amount}
              onChange={(e) => handleNumberInputChange("amount", e.target.value)}
            />
          </NumberInput>
        </FormControl>
      </HStack>

      <FormControl>
        <FormLabel>Sort Order</FormLabel>
        <NumberInput min={1}>
          <NumberInputField
            name="sort_order"
            value={currentPlan.sort_order}
            onChange={(e) => handleNumberInputChange("sort_order", e.target.value)}
          />
        </NumberInput>
      </FormControl>

      <FormControl>
        <FormLabel>Subscription Features</FormLabel>
        {currentPlan.subscription_feature.map((feature, index) => (
          <HStack key={index} mt={2}>
            <Input
              placeholder="Feature"
              value={feature.feature}
              onChange={(e) => handleFeatureChange(index, "feature", e.target.value)}
            />
            <NumberInput min={1}>
              <NumberInputField
                placeholder="Sort Order"
                value={feature.sort_order}
                onChange={(e) => handleFeatureChange(index, "sort_order", e.target.value)}
              />
            </NumberInput>
            <Button onClick={() => removeFeature(index)} colorScheme="red">
              Remove
            </Button>
          </HStack>
        ))}
        <Button onClick={addFeature} mt={2}>
          Add Feature
        </Button>
      </FormControl>

      <HStack width="100%">
        <FormControl>
          <FormLabel>Validity</FormLabel>
          <NumberInput min={1}>
            <NumberInputField
              name="validity"
              value={currentPlan.validity}
              onChange={(e) => handleNumberInputChange("validity", e.target.value)}
            />
          </NumberInput>
        </FormControl>

        <FormControl>
          <FormLabel>Validity Type</FormLabel>
          <Select name="validity_type" value={currentPlan.validity_type} onChange={handleInputChange}>
            <option value="day">Day</option>
            <option value="month">Month</option>
            <option value="year">Year</option>
          </Select>
        </FormControl>
      </HStack>

      <FormControl>
        <FormLabel>Status</FormLabel>
        <Select name="status" value={currentPlan.status} onChange={handleInputChange}>
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </Select>
      </FormControl>

      <FormControl>
        <FormLabel>Profile Creation</FormLabel>
        <Switch isChecked={currentPlan.profile_creation} onChange={() => handleSwitchChange("profile_creation")} />
      </FormControl>

      <FormControl>
        <FormLabel>Notification via Email/SMS/WhatsApp</FormLabel>
        <Switch
          isChecked={currentPlan.notification_via_email_sms_whatsapp}
          onChange={() => handleSwitchChange("notification_via_email_sms_whatsapp")}
        />
      </FormControl>

      {currentPlan.type === "candidate" && (
        <>
          <FormControl>
            <FormLabel>Number of Job Applications</FormLabel>
            <NumberInput min={0}>
              <NumberInputField
                name="no_of_job_apply"
                value={currentPlan.no_of_job_apply}
                onChange={(e) => handleNumberInputChange("no_of_job_apply", e.target.value)}
              />
            </NumberInput>
          </FormControl>

          <FormControl>
            <FormLabel>Resume Builder</FormLabel>
            <Switch isChecked={currentPlan.resume_builder} onChange={() => handleSwitchChange("resume_builder")} />
          </FormControl>
        </>
      )}

      {currentPlan.type === "employer" && (
        <>
          <FormControl>
            <FormLabel>Number of Job Posts</FormLabel>
            <NumberInput min={0}>
              <NumberInputField
                name="no_of_job_post"
                value={currentPlan.no_of_job_post}
                onChange={(e) => handleNumberInputChange("no_of_job_post", e.target.value)}
              />
            </NumberInput>
          </FormControl>

          <FormControl>
            <FormLabel>Number of Urgent Hiring Tags</FormLabel>
            <NumberInput min={0}>
              <NumberInputField
                name="no_of_urgent_hiring_tag"
                value={currentPlan.no_of_urgent_hiring_tag}
                onChange={(e) => handleNumberInputChange("no_of_urgent_hiring_tag", e.target.value)}
              />
            </NumberInput>
          </FormControl>

          <FormControl>
            <FormLabel>Number of Candidate Unlocks</FormLabel>
            <NumberInput min={0}>
              <NumberInputField
                name="no_of_candidate_unlock"
                value={currentPlan.no_of_candidate_unlock}
                onChange={(e) => handleNumberInputChange("no_of_candidate_unlock", e.target.value)}
              />
            </NumberInput>
          </FormControl>

          <FormControl>
            <FormLabel>Number of Job Published</FormLabel>
            <NumberInput min={0}>
              <NumberInputField
                name="no_of_job_published"
                value={currentPlan.no_of_job_published}
                onChange={(e) => handleNumberInputChange("no_of_job_published", e.target.value)}
              />
            </NumberInput>
          </FormControl>

          <FormControl>
            <FormLabel>Job Boosts</FormLabel>
            <Switch isChecked={currentPlan.job_boosts} onChange={() => handleSwitchChange("job_boosts")} />
          </FormControl>

          <FormControl>
            <FormLabel>Smart Boost via Email/SMS/WhatsApp</FormLabel>
            <Switch
              isChecked={currentPlan.smart_boost_via_email_sms_whatsapp}
              onChange={() => handleSwitchChange("smart_boost_via_email_sms_whatsapp")}
            />
          </FormControl>

          <FormControl>
            <FormLabel>Dedicated Relationship Manager</FormLabel>
            <Switch
              isChecked={currentPlan.dedicated_relationship_manager}
              onChange={() => handleSwitchChange("dedicated_relationship_manager")}
            />
          </FormControl>

          <FormControl>
            <FormLabel>Campaign via Email/SMS/WhatsApp</FormLabel>
            <Switch
              isChecked={currentPlan.campion_via_email_sms_whatsapp}
              onChange={() => handleSwitchChange("campion_via_email_sms_whatsapp")}
            />
          </FormControl>

          <FormControl>
            <FormLabel>Multiple User Login</FormLabel>
            <Switch
              isChecked={currentPlan.multiple_user_login}
              onChange={() => handleSwitchChange("multiple_user_login")}
            />
          </FormControl>

          <FormControl>
            <FormLabel>Reports</FormLabel>
            <Switch isChecked={currentPlan.reports} onChange={() => handleSwitchChange("reports")} />
          </FormControl>

          <FormControl>
            <FormLabel>Company Branding</FormLabel>
            <Switch isChecked={currentPlan.company_branding} onChange={() => handleSwitchChange("company_branding")} />
          </FormControl>
        </>
      )}
    </VStack>
  )

  return (
    <div className=" bg-adminbg rounded p-4" style={{ fontFamily: "Inter, sans-serif" }}>
      <Container maxW="container.2xl" className="bg-white my-2 rounded-md">
        <Flex justifyContent="space-between" alignItems="center" mb={6}>
          <h2 className="text-xl text-black font-semibold px-3 py-7">Subscription Plans</h2>
          <Button 
            leftIcon={<AddIcon />}
            colorScheme="blue" 
            onClick={() => { 
              setCurrentPlan(initialPlanState)
              onAddOpen()
            }}
          >
            Add New Plan
          </Button>
        </Flex>

        <VStack spacing={4} mb={8}>
          <HStack width="100%" spacing={4}>
            <InputGroup>
              <InputLeftElement pointerEvents="none">
                <SearchIcon color="gray.300" />
              </InputLeftElement>
              <Input placeholder="Search plans..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
            </InputGroup>
            <Select value={userTypeFilter} onChange={(e) => setUserTypeFilter(e.target.value)}>
              <option value="all">All User Types</option>
              <option value="employer">Employer</option>
              <option value="candidate">Candidate</option>
            </Select>
            <Select value={subscriptionTypeFilter} onChange={(e) => setSubscriptionTypeFilter(e.target.value)}>
              <option value="all">All Subscription Types</option>
              <option value="Premium">Premium</option>
              <option value="Basic">Basic</option>
              <option value="Standard">Standard</option>
              <option value="Custom">Custom</option>
            </Select>
          </HStack>
        </VStack>

        <TableContainer>
          <Table colorScheme="gray" size="sm">
            <Thead className="bg-gray-200">
              <Tr className="">
                <Th width="40px">
                  <Checkbox
                    isChecked={selectedPlans.length === filteredPlans.length && filteredPlans.length > 0}
                    onChange={toggleSelectAll}
                  />
                </Th>
                <Th>Title</Th>
                <Th>Type</Th>
                <Th>Subscription</Th>
                <Th>Amount</Th>
                <Th>Validity</Th>
                <Th>Status</Th>
                <Th>Actions</Th>
              </Tr>
            </Thead>
            <Tbody>
              {filteredPlans.map((plan) => (
                <Tr key={plan.uuid}>
                  <Td>
                    <Checkbox
                      isChecked={selectedPlans.includes(plan.uuid)}
                      onChange={() => togglePlanSelection(plan.uuid)}
                    />
                  </Td>
                  <Td fontWeight="medium">{plan.title}</Td>
                  <Td>
                    <Badge colorScheme={plan.type === "employer" ? "green" : "purple"}>{plan.type}</Badge>
                  </Td>
                  <Td>{plan.subscription_type}</Td>
                  <Td>
                    ₹{plan.amount}
                    <Text as="span" fontSize="sm" color="gray.500" ml={2}>
                      <s>₹{plan.mrp_amount}</s>
                    </Text>
                  </Td>
                  <Td>
                    {plan.validity} {plan.validity_type}
                    {plan.validity !== 1 ? "s" : ""}
                  </Td>
                  <Td>
                    <Badge colorScheme={plan.status === "active" ? "green" : "red"}>{plan.status}</Badge>
                  </Td>
                  <Td>
                    <HStack spacing={2}>
                      <IconButton
                        aria-label="View plan"
                        icon={<ViewIcon />}
                        size="sm"
                        colorScheme="blue"
                        variant="outline"
                        onClick={() => handleViewPlan(plan)}
                      />
                      <IconButton
                        aria-label="Edit plan"
                        icon={<EditIcon />}
                        size="sm"
                        colorScheme="green"
                        variant="outline"
                        onClick={() => handleEditPlan(plan)}
                      />
                      <IconButton
                        aria-label="Delete plan"
                        icon={<DeleteIcon />}
                        size="sm"
                        colorScheme="red"
                        variant="outline"
                        onClick={() => handleDeleteConfirmation(plan.uuid)}
                      />

                    </HStack>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>

        {/* Add Plan Modal */}
        <Modal isOpen={isAddOpen} onClose={onAddClose} size="5xl" isCentered>
          <ModalOverlay />
          <ModalContent maxHeight={"80vh"}>
            <ModalHeader>Add New Plan</ModalHeader>
            <ModalCloseButton />
            <ModalBody overflowY="auto" >
              {renderPlanForm()}
            </ModalBody>
            <ModalFooter className="bg-textBlue">
              <Button colorScheme="blue" mr={3} onClick={handleAddPlan}>
                Add
              </Button>
              <Button variant="ghost" onClick={onAddClose}>
                Cancel
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        {/* Edit Plan Modal */}
        <Modal isOpen={isEditOpen} onClose={onEditClose} size="5xl">
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Edit Plan</ModalHeader>
            <ModalCloseButton />
            <ModalBody overflowY="auto" maxHeight="calc(100vh - 200px)">
              {renderPlanForm()}
            </ModalBody>
            <ModalFooter className="bg-textBlue">
              <Button colorScheme="blue" mr={3} onClick={handleUpdatePlan}>
                Update
              </Button>
              <Button variant="ghost" onClick={onEditClose}>
                Cancel
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        {/* Delete Plan Modal */}
        <Modal isOpen={isDeleteOpen} onClose={onDeleteClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Delete Plan</ModalHeader>
            <ModalCloseButton />
            <ModalBody>Are you sure you want to delete the plan "{currentPlan.title}"?</ModalBody>
            <ModalFooter>
              <Button colorScheme="red" mr={3} onClick={handleDeletePlan}>
                Delete
              </Button>
              <Button variant="ghost" onClick={onDeleteClose}>
                Cancel
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        {/* View Plan Modal */}
        <Modal isOpen={isViewOpen} onClose={onViewClose} size="5xl">
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>View Plan Details</ModalHeader>
            <ModalCloseButton />
            <ModalBody overflowY="auto" maxHeight="calc(100vh - 200px)">
              <VStack align="start" spacing={4}>
                <Text>
                  <strong>Type:</strong> {currentPlan.type}
                </Text>
                <Text>
                  <strong>Title:</strong> {currentPlan.title}
                </Text>
                <Text>
                  <strong>Description:</strong> {currentPlan.description}
                </Text>
                <Text>
                  <strong>Subscription Type:</strong> {currentPlan.subscription_type}
                </Text>
                <Text>
                  <strong>MRP Amount:</strong> ₹{currentPlan.mrp_amount}
                </Text>
                <Text>
                  <strong>Amount:</strong> ₹{currentPlan.amount}
                </Text>
                <Text>
                  <strong>Validity:</strong> {currentPlan.validity} {currentPlan.validity_type}
                  {currentPlan.validity !== 1 ? "s" : ""}
                </Text>
                <Text>
                  <strong>Status:</strong> {currentPlan.status}
                </Text>
                <Text>
                  <strong>Features:</strong>
                </Text>
                <VStack align="start" pl={4}>
                  {currentPlan.subscription_feature.map((feature, index) => (
                    <Text key={index}>• {feature.feature}</Text>
                  ))}
                </VStack>
                {currentPlan.type === "employer" ? (
                  <>
                    <Text>
                      <strong>Number of Job Posts:</strong> {currentPlan.no_of_job_post}
                    </Text>
                    <Text>
                      <strong>Number of Urgent Hiring Tags:</strong> {currentPlan.no_of_urgent_hiring_tag}
                    </Text>
                    <Text>
                      <strong>Number of Candidate Unlocks:</strong> {currentPlan.no_of_candidate_unlock}
                    </Text>
                    <Text>
                      <strong>Number of Job Published:</strong> {currentPlan.no_of_job_published}
                    </Text>
                    <Text>
                      <strong>Job Boosts:</strong> {currentPlan.job_boosts ? "Yes" : "No"}
                    </Text>
                    <Text>
                      <strong>Smart Boost via Email/SMS/WhatsApp:</strong>{" "}
                      {currentPlan.smart_boost_via_email_sms_whatsapp ? "Yes" : "No"}
                    </Text>
                    <Text>
                      <strong>Dedicated Relationship Manager:</strong>{" "}
                      {currentPlan.dedicated_relationship_manager ? "Yes" : "No"}
                    </Text>
                    <Text>
                      <strong>Campaign via Email/SMS/WhatsApp:</strong>{" "}
                      {currentPlan.campion_via_email_sms_whatsapp ? "Yes" : "No"}
                    </Text>
                    <Text>
                      <strong>Multiple User Login:</strong> {currentPlan.multiple_user_login ? "Yes" : "No"}
                    </Text>
                    <Text>
                      <strong>Reports:</strong> {currentPlan.reports ? "Yes" : "No"}
                    </Text>
                    <Text>
                      <strong>Company Branding:</strong> {currentPlan.company_branding ? "Yes" : "No"}
                    </Text>
                  </>
                ) : (
                  <>
                    <Text>
                      <strong>Profile Creation:</strong> {currentPlan.profile_creation ? "Yes" : "No"}
                    </Text>
                    <Text>
                      <strong>Number of Job Applications:</strong> {currentPlan.no_of_job_apply}
                    </Text>
                    <Text>
                      <strong>Resume Builder:</strong> {currentPlan.resume_builder ? "Yes" : "No"}
                    </Text>
                    <Text>
                      <strong>Notification via Email/SMS/WhatsApp:</strong>{" "}
                      {currentPlan.notification_via_email_sms_whatsapp ? "Yes" : "No"}
                    </Text>
                  </>
                )}
              </VStack>
            </ModalBody>
            <ModalFooter>
              <Button colorScheme="blue" mr={3} onClick={onViewClose}>
                Close
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Container>
    </div>
  )
}

export default CreatePlan